import { Navigate, Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';

import AgentLayout from './components/AgentLayout';
import CreateLink from './components/CreateLink';
import { AGENT_ROUTES } from './routes';
import AgentDashboard from './components/Dashboard';
//import ResetPassword from './containers/ResetPassword';

const AgentContainer = () => (
  <Routes>
    <Route element={<AgentLayout />}>
      <Route index element={<Navigate replace to={AGENT_ROUTES.dashboard.to} />} />
      <Route path={AGENT_ROUTES.createLink.path} element={<CreateLink />} />
      <Route path={AGENT_ROUTES.dashboard.path} element={<AgentDashboard />} />
      {/* <Route path={AUTH_ROUTES.signUp.path} element={<SignUp />} /> */}
      {/* <Route path={AUTH_ROUTES.forgottenPassword.path} element={<ForgottenPassword />} /> */}
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default AgentContainer;
